/**
 * Home Page - Landing page with hero section and key information
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
// TODO: Club customization - re-enable when implementing club customization feature
// import { useTenant } from '../contexts/TenantContext';
import styles from './Home.module.css';
import soccerGoalImage from '../assets/soccer-goal-image.jpg';

const Home = () => {
  const { isAuthenticated } = useAuth();
  // TODO: Club customization (branding, colors, content) will be implemented
  // as part of the club customization feature
  // const { clubDisplayName, clubDescription, clubColors } = useTenant();

  return (
    <div className="home-page">
      {/* Template-Inspired Hero Section with Split Layout */}
      <section className="hero-template hero-with-soccer-bg">
        <div className={`dotted-pattern-dark ${styles.dottedOverlay}`}></div>

        {/* 40-60 split layout with overflow capability */}
        <div className={styles.heroLayout}>

          {/* 3. LEFT SECTION - Contains both The Worlds Pitch and everyone (40%) */}
          <div className={styles.leftSection}>

            {/* 1. The Worlds Pitch Section */}
            <div>
              <p
                className={styles.clubTitle}
                // TODO: Enable for club customization
                // style={{ color: clubColors?.primary || 'var(--color-primary)' }}
              >
                {/* TODO: Enable for club customization */}
                {/* {clubDisplayName || 'Youth Soccer Development'} */}
                Youth Soccer Development
              </p>

              {/* TODO: Enable for club customization */}
              {/* {clubDescription && (
                <p className={styles.clubDescription}>
                  {clubDescription}
                </p>
              )} */}
            </div>

            {/* 2. everyone Section - Can overflow into right section */}
            <div className={`green-accent-section ${styles.greenAccentSection}`}>
              <h2 className={`display-title on-green ${styles.displayTitle}`}>
                everyone<br />
                DESERVES TO<br />
                PLAY
              </h2>
              <p className={styles.missionText}>
                We remove financial barriers and deliver efficient soccer coaching for soccer players ages 5-14, providing kids with the opportunity to take their game to the next level.
              </p>
              <div className={styles.heroActions}>

                <Link to="/programs" className={`btn ${styles.btnPrimary}`}>
                  View Programs
                </Link>
                <Link to="/about" className={`btn ${styles.btnSecondary}`}>
                  Our Story
                </Link>
                {!isAuthenticated && (
                  <Link to="/auth" className={`btn ${styles.btnRegister}`}>
                    Sign In
                  </Link>
                )}
              </div>
            </div>


          </div>

          {/* 4. RIGHT SECTION - Soccer goal image (60% with overflow from left) */}
          <div
            className={styles.rightSection}
            style={{ backgroundImage: `url(${soccerGoalImage})` }}
          >
            {/* Soccer goal with ball in net */}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
